import { RootState } from "@/app/stores"
import { createPartnerDiscount, deletePartnerDiscount, ICreatePartnerDiscount, IPartnerDiscount, IUpdatePartnerDiscount } from "@/shared/api/partners"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { updatePartnerDiscount } from "@/shared/api/partners"
import { AxiosError } from "axios"
import { ErrorType } from "@/shared/types"

export const fetchUpdatePartnerDiscount = createAsyncThunk<
    IPartnerDiscount,
    IUpdatePartnerDiscount,
    { state: RootState }
>('updatePartnerDiscount/fetchUpdatePartnerDiscount', async (data, thunkAPI) => {
    try {
        const { currentDiscount } = thunkAPI.getState().updatePartnerDiscount
        const response = await updatePartnerDiscount(currentDiscount.id, data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchDeletePartnerDiscount = createAsyncThunk<
    void,
    void,
    { state: RootState }
>('updatePartnerDiscount/fetchDeletePartnerDiscount', async (_, thunkAPI) => {
    try {
        const { currentDiscount } = thunkAPI.getState().updatePartnerDiscount
        const response = await deletePartnerDiscount(currentDiscount.id)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchCreatePartnerDiscount = createAsyncThunk<
    IPartnerDiscount,
    ICreatePartnerDiscount,
    { state: RootState }
>('updatePartnerDiscount/fetchCreatePartnerDiscount', async (data, thunkAPI) => {
    try {
        const response = await createPartnerDiscount(data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})